import * as Sentry from '@sentry/vue';
import loggedUserResource from '@/commons/resources/loggedUser';
import config from '@/config';

const setup = app => {
  const dsn = config?.app?.sentry?.dsn;
  const isProd = process.env.VUE_APP_MODE === 'production';

  if (dsn) {
    Sentry.init({
      app,
      dsn,
      logErrors: !isProd,
      debug: !isProd,
      environment: process.env.VUE_APP_MODE,
      release: process.env.VUE_APP_SENTRY_RELEASE,
      trackComponents: true,
      initialScope: {
        user: loggedUserResource.get()
      }
    });

    /**
     * TODO: remove this when we will have a better way to handle the new relic tracing with sentry.io
     * https://www.notion.so/transfeera/ADR-001-APM-a704f0d0d2e64f6c97b0b62cd69125c1
     * **/
    if (typeof window.newrelic !== 'undefined' && typeof window.newrelic.setErrorHandler === 'function') {
      window.newrelic.setErrorHandler(function (error) {
        Sentry.captureException(error, { extra: { newrelic: 'yes' } });
      });
    }
  }
};

export default {
  setup
};
